import { put, takeLatest, call, getContext, select, all } from 'redux-saga/effects';

import { SagaIterator } from 'redux-saga';

import { IRequestInformationAction, ActionTypes } from './Information.action-types';
import { IInformationState, IInformationResponse, IRoleResponse, INonTARUserResponse } from './Information.types';
import { INITIAL_INFORMATION } from './Information.reducer';
import { receiveInformation } from './Information.actions';
import moment = require('moment');
import { IHttpClient, IHttpClientResult } from '@employee-experience/common/lib/Models/IHttpClient';

import IAppState from '../../../../App.types';
import { TARReducerName } from '../../TAR.resources';
import { setCalcOverride } from '../CalcOverride/CalcOverride.actions';
import { IAuthClient } from '@employee-experience/common';
import { setDateRange } from '../Filter/CalendarFilter.actions';
import { UntrackedUserErrorMsg } from './information.resources';

const getRedirection = (state: IAppState): boolean => {
    const tar = state.dynamic[TARReducerName];
    return tar && tar.adminActionTypes && tar.adminActionTypes.redirection
        ? tar.adminActionTypes.redirection.redirectionFlag
        : false;
};

const getInformation = (state: IAppState): IInformationState => {
    const tar = state.dynamic[TARReducerName];
    return tar ? tar.information : INITIAL_INFORMATION;
};

export function getWeek(date: Date): Date[] {
    const week = [];
    const day = date.getDay();

    let startOfWeek = new Date(date);
    startOfWeek.setDate(date.getDate() - day);
    startOfWeek.setHours(0, 0, 0, 0);

    for (let i = 0; i < 7; i++) {
        week.push(startOfWeek);
        startOfWeek = new Date(startOfWeek);
        startOfWeek.setDate(startOfWeek.getDate() + 1);
    }
    return week;
}

export function* fetchInformation(action: IRequestInformationAction): SagaIterator {
    const httpClient: IHttpClient = yield getContext('httpClient');
    const authClient: IAuthClient = yield getContext('authClient');
    const email = yield call([authClient, authClient.getUserId]);
    const alias = email?.split('@')[0];
    const date: Date | undefined = action.data && action.data.date ? action.data.date : undefined;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const userUrl = __API_ENDPOINT__ + `userinfo`;

    let infoUrl = __API_ENDPOINT__ + `employees?alias=${alias}`;

    const nontaruserinfoUrl = __API_ENDPOINT__ + `employees/${alias}/nontaruserinfo`;

    if (action.data && action.data.perner) {
        if (action.data.alias) {
            infoUrl =
                __API_ENDPOINT__ +
                `employees?perner=${action.data.perner}&alias=${action.data.alias}&effectiveDate=${moment(date).format(
                    'DD MMM, YYYY'
                )}`;
        } else
            infoUrl =
                __API_ENDPOINT__ +
                `employees?perner=${action.data.perner}&effectiveDate=${moment(date).format('DD MMM, YYYY')}`;
    }
    let success = true;
    let data: IInformationState = yield select(getInformation);

    try {
        if (action.data && action.data.start && action.data.perner) {
            const { data: info }: IHttpClientResult<IInformationResponse> = yield call(
                [httpClient, httpClient.request],
                {
                    url: infoUrl
                }
            );

            if (info) {
                data = {
                    apiUpdateStatus: false,
                    name: info.fullName,
                    emailName: info.emailName,
                    perner: info.personnelNbr,
                    subgroup: info.hrPersonSubGroupCode + ' ' + info.hrPersonSubGroupDesc,
                    status: info.employeeStatus,
                    payPeriod: '',
                    isAdmin: data.isAdmin,
                    tarUser: info.tarUser,
                    hrPersonSubGroupCode: info.hrPersonSubGroupCode,
                    salaried: parseInt(info.personSubGroupCode) === 5,
                    effectiveStartDate: new Date(info.effectiveStartDate),
                    hireDate: new Date(info.hireDate),
                    payCycleCode: info.payCycleCode,
                    wob: info.emailName ? info.emailName.toUpperCase() !== alias.toUpperCase() : true,
                    companyCode: info.companyCode,
                    costCenterCode: info.costCenterCode,
                    adminRoleTypeCode: data.adminRoleTypeCode,
                    untrackedUser: data.untrackedUser,
                    isFormerTARUser: data.isFormerTARUser,
                    isTARManager: data.isTARManager,
                    dtoEnabled: info.dtoEnabled,
                    dcopsBannerFlag: info.dcopsBannerFlag
                    
                };
            }
        } else {
            const [{ data: info }, { data: role }, { data: nonTARUserInfo }]: [
                IHttpClientResult<IInformationResponse>,
                IHttpClientResult<IRoleResponse>,
                IHttpClientResult<INonTARUserResponse>
            ] = yield all([
                call([httpClient, httpClient.request], {
                    url: infoUrl
                }),
                call([httpClient, httpClient.request], {
                    url: userUrl
                }),
                call([httpClient, httpClient.request], {
                    url: nontaruserinfoUrl
                })
            ]);

            if (info) {
                data = {
                    apiUpdateStatus: false,
                    name: info.fullName,
                    emailName: info.emailName,
                    perner: info.personnelNbr,
                    subgroup: info.hrPersonSubGroupCode + ' ' + info.hrPersonSubGroupDesc,
                    status: info.employeeStatus,
                    payPeriod: '',
                    isAdmin: false,
                    tarUser: info.tarUser,
                    hrPersonSubGroupCode: info.hrPersonSubGroupCode,
                    salaried: parseInt(info.personSubGroupCode) === 5,
                    effectiveStartDate: new Date(info.effectiveStartDate),
                    hireDate: new Date(info.hireDate),
                    payCycleCode: info.payCycleCode,
                    wob: false,
                    companyCode: info.companyCode,
                    costCenterCode: info.costCenterCode,
                    adminRoleTypeCode: 0,
                    untrackedUser: false,
                    isFormerTARUser: false,
                    isTARManager: false,
                    dtoEnabled: info.dtoEnabled,
                    dcopsBannerFlag: info.dcopsBannerFlag
                };
            } else {
                data.tarUser = false;
            }
            if (role) {
                data.isAdmin = role.isAdmin;
                data.adminRoleTypeCode = role.adminRoleTypeCode;
            }
            if (nonTARUserInfo) {
                data.isFormerTARUser = nonTARUserInfo.isFormerTARUser;
                data.isTARManager = nonTARUserInfo.isTARManager;
            }
        }
    } catch (error) {
        success = false;
        //For user whose email name is null in db, set
        //untrackedUser flag to true
        if (error.data && error.data.Detail.includes(UntrackedUserErrorMsg)) {
            data = { ...data, untrackedUser: true };
            success = true;
        }
        if (success === false) {
            if (error.data && error.data.Detail) {
                yield put(receiveInformation(data, success, error.data.Detail));
            } else yield put(receiveInformation(data, success, 'Error in getting user information'));
        }
    }
    if (success == true) {
        data.apiUpdateStatus = true;
        yield put(receiveInformation(data, success, ''));
        if (date === undefined) {
            yield put(setDateRange(getWeek(today), today, true));
        } else {
            yield put(setDateRange(getWeek(date), date, true));
        }
        yield put(setCalcOverride(false));
    }
}

export default function* informationSaga(): Generator {
    yield takeLatest(ActionTypes.INFORMATION_REQUEST, fetchInformation);
}
